import React, { Component } from 'react';
import moment from 'moment';
import { last } from 'lodash';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent } from '../../../util/responseUtil';
import API_NEWS_FEED from '../../../api/apiNewsFeed';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import IconKMSImageIcon from '../../../assets/icons/IconKMSImageIcon';
import ActionType from '../../../redux/reducer/globalActionType';

class NewsFeedDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            dataNewsFeed: {
                newsFeedId: '',
                title: '',
                description: '',
                imageFile: null,
                urlLink: '',
                status: '',
                createdAt: '',
                createdBy: '',
                updatedAt: '',
                updatedBy: '',
            },
        }
        this.toggleOffCanvas = this.toggleOffCanvas.bind(this);
    }

    toggleOffCanvas() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    getFilenameFromUrl = value => {
        if (value) {
            return last(value.split("/"));
        }
    }

    getDetailNewsFeed = (newsFeedId) => {
        API_NEWS_FEED.getDetailNewsFeed(newsFeedId, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        dataNewsFeed: {
                            newsFeedId: getContent(res).id,
                            title: getContent(res).title,
                            description: getContent(res).description,
                            urlLink: getContent(res).url_link,
                            imageFile: getContent(res).picture_link,
                            status: String(getContent(res).status),
                            createdAt: moment.utc(getContent(res).created_at).format('DD/MM/YYYY HH:mm'),
                            createdBy: `${getContent(res).created_by.first_name} ${getContent(res).created_by.last_name}`,
                            updatedAt: moment.utc(getContent(res).updated_at).format('DD/MM/YYYY HH:mm'),
                            updatedBy: getContent(res).updated_by,
                        },
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                if (err.response.data.nexsoft.payload.status.message === "Data id tidak diketahui") {
                    this.handleBackToNewsFeedList();
                    setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                }
            }))
    }

    componentDidMount() {
        this._isMounted = true;

        let setDefaultValueStatus = "true";
        let newsFeedIdFromHistoryState = this.props.match.params.id;
        this.setState({
            dataNewsFeed: {
                ...this.state.dataNewsFeed,
                status: setDefaultValueStatus
            }
        })
        this.getDetailNewsFeed(newsFeedIdFromHistoryState);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { isOpen } = this.state;

        return (
            <div className="h-full pb-12">
                <BreadCrumbs
                    parentMenu="Pengaturan"
                    serviceMenu="Berita"
                    menuItem="Detail Berita"
                    title="Detail Berita"
                />

                <div className="h-content">
                    <div className="w-max bg-gray-200 flex items-center rounded px-3 py-1 ml-auto cursor-pointer select-none" onClick={this.toggleOffCanvas}>
                        <p className=" text-gray-500 text-sm">Created By <span className="text-black">{this.state.dataNewsFeed.createdBy}</span> On <span className="text-black">{this.state.dataNewsFeed.createdAt}</span></p>
                        <span className="text-gray-500 text-sm mx-3"> | </span>
                        <p className=" text-gray-500 text-sm">Last Modified By <span className="text-black">{this.state.dataNewsFeed.updatedBy}</span> On <span className="text-black">{this.state.dataNewsFeed.updatedAt}</span></p>
                        <span className="text-gray-500 text-sm mx-3"> <FontAwesomeIcon icon={faChevronRight} /> </span>
                    </div>

                    {/* WHITECONTAINER */}
                    <div className="white-container pt-5 h-full">
                        <div className="w-full h-full bg-white border border-gray-300 rounded-lg p-8 flex item center text-gray-700">
                            <div className="w-1/4 pr-20">
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">ID</p>
                                    <p className="font-medium">{this.state.dataNewsFeed.newsFeedId}</p>
                                </div>
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">Judul</p>
                                    <p className="font-medium">{this.state.dataNewsFeed.title}</p>
                                </div>
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">Deskripsi</p>
                                    <textarea className="font-medium w-full h-96" value={this.state.dataNewsFeed.description ? this.state.dataNewsFeed.description : "Tidak ada deskripsi berita"} readOnly></textarea>
                                </div>
                            </div>
                            <div className="w-1/4 pr-20">
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">Gambar</p>
                                    <div className="flex items-center">
                                        <div className="-ml-2 mr-2">
                                            <IconKMSImageIcon />
                                        </div>
                                        <div>
                                            <p className="truncate" title={this.getFilenameFromUrl(this.state.dataNewsFeed.imageFile)}>
                                                {this.getFilenameFromUrl(this.state.dataNewsFeed.imageFile) ? this.getFilenameFromUrl(this.state.dataNewsFeed.imageFile) : "Tidak ada gambar"}
                                            </p>
                                            {
                                                this.getFilenameFromUrl(this.state.dataNewsFeed.imageFile) && <p id="btnviewpicture" className="cursor-pointer text-blue-500" onClick={() => this.setState({ showPopupImage: true })}>Lihat Icon</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">Link URL</p>
                                    <a href={this.state.dataNewsFeed.urlLink} target="_blank" rel="noreferrer" className="font-medium">{this.state.dataNewsFeed.urlLink ? this.state.dataNewsFeed.urlLink : "Tidak ada Link URL"}</a>
                                </div>
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">Status</p>
                                    <p className="font-medium">{this.state.dataNewsFeed.status === "true" ? "Aktif" : "Tidak Aktif"}</p>
                                </div>
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">Tanggal Pembuatan</p>
                                    <p className="font-medium">{this.state.dataNewsFeed.createdAt}</p>
                                </div>
                                <div className="mb-5">
                                    <p className="text-gray-400 text-sm">Dibuat Oleh</p>
                                    <p className="font-medium">{this.state.dataNewsFeed.createdBy}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Popup Modal Image */}
                    <div className={this.state.showPopupImage ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none w-5/12 min-w-min">
                                <div className="body-attachment w-full flex rounded-lg flex-col p-8 font-bold text-lg space-y-5">
                                    <div>
                                        <div className="text-2xl">{this.state.dataNewsFeed.imageFile ? this.state.dataNewsFeed.imageFile.name : ''}</div>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <img src={this.state.dataNewsFeed.imageFile && this.state.dataNewsFeed.imageFile} alt={this.state.dataNewsFeed.imageFile ? this.state.dataNewsFeed.imageFile.name : ''} className="h-96" />
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <button id="btncloseviewicon" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ showPopupImage: false })}>Tutup</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Sider */}
                    <div className={`${isOpen ? 'translate-x-0' : 'translate-x-full'} transform fixed right-0 top-0 h-full bg-white w-1/4 z-40 transition-transform duration-300 ease-in-out shadow-lg`}>
                        <div className="flex items-center justify-between pt-8 pr-8 pl-8">
                            <div>
                                <p className="text-2xl font-medium">Data Management History</p>
                                <p className="text-sm"><span className="text-gray-400">Created by</span> Jansen Manuel <span className="text-gray-400">on</span> 01/01/2023</p>
                            </div>
                            <button className="text-gray-600 hover:text-gray-800 focus:outline-none" onClick={this.toggleOffCanvas}>
                                <FontAwesomeIcon icon={faTimes} className="fa-2xl" />
                            </button>
                        </div>
                        <div className="p-8">
                            <div className="flex">
                                <div className="relative mr-5 z-10 flex flex-col items-center">
                                    <div className="w-3 h-3 bg-darkblue rounded-full absolute top-4"></div>
                                    <div className="w-px h-full bg-gray-400 absolute top-7"></div>
                                </div>
                                <div className="border-b border-gray-400 w-full p-3">
                                    <p className="text-darkblue ">Last Modified</p>
                                    <p className="">Jansen Manuel</p>
                                    <p className="text-gray-400">01/03/2023 12.00 PM</p>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="relative mr-5 z-10 flex flex-col items-center">
                                    <div className="w-3 h-3 bg-gray-400 rounded-full absolute top-4"></div>
                                    <div className="w-px h-full bg-gray-400 absolute top-7"></div>
                                </div>
                                <div className="border-b border-gray-400 w-full p-3">
                                    <p className="">Modified</p>
                                    <p className="">Jansen Manuel</p>
                                    <p className="text-gray-400">01/02/2023 12.00 PM</p>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="relative mr-5 z-10 flex flex-col items-center">
                                    <div className="w-3 h-3 bg-gray-400 rounded-full absolute top-4"></div>
                                    {/* <div className="w-px h-full bg-gray-400 absolute top-7"></div> */}
                                </div>
                                <div className="border-b border-gray-400 w-full p-3">
                                    <p className="">Created</p>
                                    <p className="">Jansen Manuel</p>
                                    <p className="text-gray-400">01/01/2023 12.00 PM</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsFeedDetail);